import { BaseError } from './base-error';

export class InvalidCastError extends BaseError {
  public readonly name = 'InvalidCastError';

  constructor(message: string, context?: Error | any, parentError?: Error) {
    super(message, context, parentError);
  }
}